export enum ParserType {
  Date = 'date',
  Dropdown = 'dropdown',
  RelationGroup = 'group',
  InlineGroup = 'inline-group',
  List = 'list',
  Lookup = 'lookup',
  LookupName = 'lookup-name',
  LookupRelation = 'lookup-relation',
  Onebox = 'onebox',
  Name = 'name',
  Series = 'series',
  Tag = 'tag',
  Textarea = 'textarea'
}
